var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBarImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.348 9.10842L7.88279 6.63308C8.51662 5.90563 8.86391 4.99035 8.86391 4.0375C8.86391 1.81126 6.98785 0 4.68195 0C2.37606 0 0.5 1.81126 0.5 4.0375C0.5 6.26374 2.37606 8.07499 4.68195 8.07499C5.54762 8.07499 6.37255 7.82291 7.07785 7.34438L9.56175 9.8385C9.66557 9.9426 9.80521 10 9.95485 10C10.0965 10 10.2309 9.94786 10.3329 9.85307C10.5496 9.65172 10.5565 9.31784 10.348 9.10842ZM4.68195 1.05326C6.38637 1.05326 7.77296 2.39195 7.77296 4.0375C7.77296 5.68304 6.38637 7.02173 4.68195 7.02173C2.97754 7.02173 1.59094 5.68304 1.59094 4.0375C1.59094 2.39195 2.97754 1.05326 4.68195 1.05326Z",
    fill: "current",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBarImg);
export default __webpack_public_path__ + "static/media/searchBarIMG.4b9d9c49e1612756de899a18efa93b99.svg";
export { ForwardRef as ReactComponent };